import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";

class GolfClubReports extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Golf Club Reports</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/golf-clubs/tee-time-completion-rate'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee-Time Completion Rate
                                </h3>
                                <p className='card-text'>
                                    View each golf club's all-time tee-time
                                    request completion rate.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/golf-clubs/tee-time-revenue'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee-Time Revenue
                                </h3>
                                <p className='card-text'>
                                    View total all-time tee-time booking revenue
                                    by golf club.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/golf-clubs/tee-time-booking-outcome-mix'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee-Time Booking Outcome Mix
                                </h3>
                                <p className='card-text'>
                                    View booked and cancelled tee-time outcomes
                                    by golf club.
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default GolfClubReports;
